import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      '.wide-container': {
        width: '100%',
        maxWidth: 1360,
        margin: '0 auto',
        padding: '0 16px',
      },
      '.narrow-container': {
        width: '100%',
        maxWidth: 1129,
        margin: '0 auto',
        padding: '0 16px',
      },
    },
    sectionList: {
      position: 'relative',
      //   backgroundColor: theme.colors.neutral[0],
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 80,
    },

    bg: {
      position: 'absolute',
      zIndex: 0,
      top: 0,
    },
    section: {},
    wrapper: {},
  }
})
